import { useQuery } from '@tanstack/react-query';
import { request } from './client.ts';
import { qk } from './keys.ts';

// Proactive "needs attention" items (docs/05 proactive v1). GET /v1/attention is computed
// on the fly server-side; the Dashboard renders the non-empty result as a compact card.

// Known kinds today. Sprint 10 adds analytics-driven ones (uptime_drop,
// unplayed_media, long_broadcast) and more will follow — so `type` is a plain
// string and the UI renders every item generically (icon fallback, text-first),
// never switching on a closed set (docs/05 proactive v2).
export type AttentionType = string;

/** Pages an attention item can deep-link to. Unknown values render without a link. */
export type AttentionPage = 'screens' | 'schedules' | 'playlists' | 'analytics';

export interface AttentionItem {
  id: string;
  type: AttentionType;
  severity: 'warn' | 'info';
  title: string;
  detail?: string;
  /** Optional — some kinds (e.g. a long-running broadcast) have no single target. */
  link?: { page: AttentionPage; id: string };
  ask: string;
}

export function getAttention(): Promise<AttentionItem[]> {
  return request<{ items: AttentionItem[] }>('/attention').then((r) => r.items ?? []);
}

export function useAttention() {
  return useQuery({ queryKey: qk.attention, queryFn: getAttention });
}
